import { createSelector } from '@reduxjs/toolkit'

export const faqSelector = state => state.faqReducer

export const getFetching = () =>
  createSelector(faqSelector, faq => faq.fetching)

export const getFaqs = () => createSelector(faqSelector, faq => faq.faqs)
